"use strict";

var Backbone    = require("backbone");
var $           = require("jquery");
var _           = require("underscore");
Backbone.$      = $;

var debug       = require("debug")("views:SearchInputView");    //https://github.com/visionmedia/debug

// SearchInputView : bind a text input and a query model
module.exports = Backbone.View.extend({

    model:null,
    fieldName:null,

    events: {
        "keypress": "onKeyPress",
        "blur":     "onBlur",
        "focus":    "onFocus"
    },

    initialize:function(options){
        var T=this;
        _.extend(T, options);
        T.listenTo(T.model, "change:"+T.fieldName, T.render); 
    },

    render: function(){
        var T=this;
        debug("render "+T.fieldName);
        T.$el.val(T.model.get(T.fieldName));
        return T;
    },

    search: function () {
        var T=this;
        T.model.search();    
    },

    getInputValue:function(){
        return this.$el.val();
    },

    onBlur:function(){
        var T=this;
        T.model.set(T.fieldName,T.getInputValue());
    },

    onFocus:function(){
        var T=this;
        setTimeout(function(){
            T.$el.select();
        },0);
    },

    onKeyPress: function (ev) {
        var T=this;
        if (ev.keyCode === 13) { // enter key pressed
            ev.preventDefault();
            T.model.set(T.fieldName,T.getInputValue());
            T.$el.blur(); // pour refermer le clavier android
            T.trigger("submit");
        }
    },

    close:function(){
        var T=this;
        T.stopListening();
        T.undelegateEvents();
    }

});